// ScreenBlocker.jsx
export default function ScreenBlocker({ show, message = 'Please wait...' }) {
    if (!show) return null;
  
    return (
      <div style={styles.overlay}>
        <div style={styles.loader}>{message}</div>
      </div>
    );
  }
  
  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    },
    loader: {
      color: '#fff',
      fontSize: '18px',
    },
  };
  